import React from "react";

const ErrorAlert = ({ message }) => (
  <div className="login-error-box">
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#b91c1c"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, marginTop: "1px" }}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    {message}
  </div>
);

const EmailAuthStep = ({ flow }) => {
  const {
    userEmail,
    sendingEmail,
    emailSent,
    alert,
    handleSendEmailLink,
    resetFromEmailAuth,
  } = flow;

  return (
    <div className="login-step">
      {alert.show && <ErrorAlert message={alert.message} />}

      <p className="login-otp-hint" style={{ paddingBottom: "12px" }}>
        {emailSent ? (
          <>
            Login link sent to <span className="login-otp-phone">{userEmail}</span>.
            Open it on this device to finish logging in.
          </>
        ) : (
          <>
            SMS codes aren&apos;t working for this number. We&apos;ll send a login link
            to <span className="login-otp-phone">{userEmail}</span> instead — open it
            on this device to continue.
          </>
        )}
      </p>

      {!emailSent && (
        <button
          className={`login-btn-primary${sendingEmail ? " login-btn-primary--loading" : ""}`}
          onClick={handleSendEmailLink}
          disabled={sendingEmail}
        >
          {sendingEmail ? (
            <>
              <span className="login-btn-spinner" />
              Sending link…
            </>
          ) : (
            "Send login link"
          )}
        </button>
      )}

      <div className="login-otp-footer">
        <button className="login-btn-back" onClick={resetFromEmailAuth}>
          ← Change number
        </button>

        {emailSent && (
          <button
            className={`login-resend-btn${sendingEmail ? " login-resend-btn--blocked" : ""}`}
            disabled={sendingEmail}
            onClick={handleSendEmailLink}
          >
            Resend link
          </button>
        )}
      </div>
    </div>
  );
};

export default EmailAuthStep;
